import { useCallback, ReactElement } from "react";
import { OtherLocalesConfig } from "@evergiving/common/dist/es2015/form";
import { useFormRouter } from "@/lib/hooks/useFormRouter";
import { CountryFlag } from "@/lib/components/CountryFlag";
import { getCountryFromLocale } from "@/lib/config/localeUtils";
import { getFlag } from "@/lib/dynamic/countryFlagsForSwitcher";

function SwitchToCountry({
  locale,
  descriptionText,
}: {
  locale: string;
  descriptionText: string;
}): ReactElement {
  const formRouter = useFormRouter();

  const currentLocaleCountry = getCountryFromLocale(
    formRouter.getCurrentLocale()
  );

  const handleClick = useCallback(() => {
    formRouter.replaceWithLocale(locale);
  }, [formRouter, locale]);

  return (
    <li className="switchToCountry">
      <button type="button" onClick={handleClick} title={descriptionText}>
        {getCountryFromLocale(locale) === currentLocaleCountry ? (
          descriptionText
        ) : (
          <CountryFlag
            countryCode={getCountryFromLocale(locale)}
            getFlag={getFlag}
          />
        )}
      </button>
    </li>
  );
}

export function CountrySwitcher({
  otherLocales,
}: {
  otherLocales: OtherLocalesConfig;
}): ReactElement {
  return (
    <ul className="countrySwitcher">
      {Object.entries(otherLocales).map(([locale, { descriptionText }]) => (
        <SwitchToCountry
          key={locale}
          locale={locale}
          descriptionText={descriptionText}
        />
      ))}
    </ul>
  );
}
